import { VApp } from 'vuetify/lib/components/VApp';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c('router-view',{attrs:{"name":"e-agent"}}),_c('router-view',{attrs:{"name":"e-wallboard"}}),_c('router-view',{attrs:{"name":"ms-teams"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }